var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrackYellowTemp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    viewBox: "0 0 9 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90046 5.51803C4.90046 5.21483 4.65467 4.96904 4.35147 4.96904C4.04828 4.96904 3.80249 5.21483 3.80249 5.51803V10.1687C2.9576 10.4077 2.33852 11.1845 2.33852 12.1059C2.33852 13.2176 3.23975 14.1188 4.35147 14.1188C5.4632 14.1188 6.36443 13.2176 6.36443 12.1059C6.36443 11.1845 5.74535 10.4077 4.90046 10.1687V5.51803ZM3.4365 12.1059C3.4365 11.6005 3.84615 11.1909 4.35147 11.1909C4.8568 11.1909 5.26645 11.6005 5.26645 12.1059C5.26645 12.6112 4.8568 13.0208 4.35147 13.0208C3.84615 13.0208 3.4365 12.6112 3.4365 12.1059Z",
    fill: "url(#paint0_linear_109_499)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36997 0.577149H4.33298C4.00749 0.577143 3.73575 0.577139 3.51268 0.592367C3.28046 0.608219 3.0611 0.642394 2.84846 0.730523C2.35551 0.934818 1.96385 1.32648 1.75956 1.81942C1.67143 2.03207 1.63725 2.25142 1.6214 2.48364C1.60617 2.70672 1.60618 2.97845 1.60618 3.30394L1.60619 8.91547C0.710817 9.68662 0.142578 10.83 0.142578 12.1059C0.142578 14.4304 2.02697 16.3148 4.35147 16.3148C6.67598 16.3148 8.56037 14.4304 8.56037 12.1059C8.56037 10.83 7.99213 9.68662 7.09677 8.91547V3.30396C7.09677 2.97846 7.09677 2.70672 7.08155 2.48364C7.0657 2.25142 7.03152 2.03207 6.94339 1.81942C6.7391 1.32648 6.34744 0.934818 5.85449 0.730523C5.64185 0.642394 5.4225 0.608219 5.19027 0.592367C4.9672 0.577139 4.69546 0.577143 4.36997 0.577149ZM3.26883 1.74484C3.32533 1.72142 3.41116 1.69982 3.58746 1.68779C3.76868 1.67542 4.00273 1.67512 4.35147 1.67512C4.70022 1.67512 4.93427 1.67542 5.11549 1.68779C5.29179 1.69982 5.37762 1.72142 5.43412 1.74484C5.65819 1.8377 5.83622 2.01573 5.92908 2.23979C5.95249 2.29629 5.97409 2.38213 5.98612 2.55842C5.99849 2.73965 5.99879 2.9737 5.99879 3.32244V9.17794C5.99879 9.35057 6.08 9.51315 6.21802 9.61685C6.97469 10.1854 7.4624 11.0886 7.4624 12.1059C7.4624 13.824 6.06959 15.2168 4.35147 15.2168C2.63336 15.2168 1.24055 13.824 1.24055 12.1059C1.24055 11.0886 1.72826 10.1854 2.48493 9.61685C2.62295 9.51315 2.70416 9.35057 2.70416 9.17794V3.32244C2.70416 2.9737 2.70446 2.73965 2.71683 2.55842C2.72886 2.38213 2.75046 2.29629 2.77387 2.23979C2.86673 2.01573 3.04476 1.8377 3.26883 1.74484Z",
    fill: "url(#paint1_linear_109_499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_499",
    x1: 5.14458,
    y1: 10.8441,
    x2: 7.26643,
    y2: 10.8473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_109_499",
    x1: 5.14458,
    y1: 10.8441,
    x2: 7.26643,
    y2: 10.8473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDBD4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99D633"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrackYellowTemp);
export default __webpack_public_path__ + "static/media/crack-yellow-temp.368a8340a0ba956d92fed013f9edcfe1.svg";
export { ForwardRef as ReactComponent };